/*eslint-disable*/
import cloneDeep from 'lodash/cloneDeep';
import Cookies from 'js-cookie';
import { JSEncrypt } from 'jsencrypt';
import { v4 as uuidv4 } from 'uuid';


export function clone(data) {
	return cloneDeep(data);
}

export function getUrlKey(name) { // 获取url 参数
	return decodeURIComponent((new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[,""])[1].replace(/\+/g,'%20')) || null;
}

export function getNavigatorLang() {
	let lang = navigator.language;
	const langTolowercase = lang.toLowerCase();

	if (['en-gb', 'en-us'].includes(langTolowercase)) {
		lang = 'en';
	} else if (['ko-kr'].includes(langTolowercase)) {
		lang = 'ko';
	} else if (['th-th'].includes(langTolowercase)) {
		lang = 'th';
	} else if (['pt-br', 'pt-pt'].includes(langTolowercase)) {
		lang = 'pt';
	}

	return lang;
}

// 获取设备平台信息 1.安卓 2.IOS 3.PC
export function getHardWare() {
	const useragent = navigator.userAgent.toLowerCase();
	let hardwarePlatform = '';
	if (useragent.match(/Android/i) == 'android') {
		hardwarePlatform = 1;
	} else if (useragent.match(/iPhone/i) == 'iphone' || useragent.match(/iPad/i) == 'ipad' || useragent.match(/Macintosh/i) == 'macintosh') {
		hardwarePlatform = 2;
	} else if (useragent.match(/Windows/i) == 'windows') {
		hardwarePlatform = 3;
	} else {
		hardwarePlatform = 3;
	}
	return hardwarePlatform;
}

// 获取app类型 1.web浏览器 2.叨鱼APP 3.微信小程序 4.支付宝小程序
export function getSoftWare() {
	const ua = navigator.userAgent.toLowerCase();
	let softwarePlatform = '';
	if (ua.match(/DaoYu/i) == 'daoyu') {
		softwarePlatform = 2;
	} else if (ua.match(/MicroMessenger/i) == 'micromessenger') {
		softwarePlatform = 3;
	// eslint-disable-next-line no-undef
	} else if (ua.match(/Alipay/i) == 'alipay' && payway === 2) {
		softwarePlatform = 4;
	} else softwarePlatform = 1;
	return softwarePlatform;
}

export function getDeploy() {
	const terminal = navigator.userAgent.toLowerCase();
	let deploy_platform = ''; // 1: pc web；2:h5，4:原生android，8：原生iOS
	const rules = /iphone|ios|android|ipod|ipad|micromessenger/i;

	if (rules.test(terminal)) {
		deploy_platform = 2;
	} else {
		deploy_platform = 1;
	}

	return deploy_platform;
}

// 获取设备平台信息 1: pc web；4:原生android，8：原生iOS
export function getDeployNew() {
	const useragent = navigator.userAgent.toLowerCase();
	let hardwarePlatform = '';
	if (useragent.match(/Android/i) == 'android') {
		hardwarePlatform = 4;
	} else if (useragent.match(/iPhone/i) == 'iphone' || useragent.match(/iPad/i) == 'ipad' || useragent.match(/Macintosh/i) == 'macintosh') {
		hardwarePlatform = 8;
	} else if (useragent.match(/Windows/i) == 'windows') {
		hardwarePlatform = 1;
	} else {
		hardwarePlatform = 1;
	}
	return hardwarePlatform;
}

export function removeSearchFromUrl(url) {
	const flag = url.includes('?');

	if (flag) {
		const index = url.indexOf('?');
		const newUrl = url.slice(0, index);
		return newUrl;
	}
	return url;
}

export function loginRsaEncrypt(pwd) {
	// 公钥
	let PUBLIC_KEY = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCrLCvPQVj1dYDdtb34bUGrxAYHLDMQdsjbk7+pY/ugKdHKhxQo1E43gt4HMgjFuirvaGfh1NJ2FCX9thillLZlHhkNOUcEQSbpcJycQ9wq7FBtOk7lE0dBBA9t3Zk/qBx2A2xPVvVNf9lNdNDDp2vXhQ549H9hg1s1TPHFEags3QIDAQAB';
	PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----${PUBLIC_KEY}-----END PUBLIC KEY-----`;

	// 使用公钥加密
	const encrypt = new JSEncrypt();
	encrypt.setPublicKey(PUBLIC_KEY);
	const encrypted = encrypt.encrypt(pwd);
	return encrypted;
}

export function parseUrl(url, params) {
	if (!url) {
		return '';
	} else if (url.includes('?')) {
		return `${url}${params ? `&${params}` : ''}`;
	} else {
		return `${url}${params ? `?${params}` : ''}`;
	}
}

export function storageEventEmit(key, value) {
	let storageEventEmiter = document.createEvent('StorageEvent');

	storageEventEmiter.initStorageEvent(
		'setItem',
		false,
		false,
		key,
		null,
		value,
		null,
		null
	);

	window.dispatchEvent(storageEventEmiter);
}

export function createUUID() {
	const uuid = uuidv4();
	return uuid;
}

export default {
	clone,
	getUrlKey,
	getHardWare,
    getSoftWare,
	getDeploy,
    removeSearchFromUrl,
	loginRsaEncrypt,
	parseUrl,
	storageEventEmit,
	createUUID,
};
